import { URL_API_PRODUCT } from 'src/config';
import baseActions from '../baseActions';
import httpService from 'src/helpers/httpService';

const path = 'public/products';
export const actionType = (action) => {
  return {
    request: `${action}_${path}_request`.toUpperCase(),
    success: `${action}_${path}_success`.toUpperCase(),
    error: `${action}_${path}_error`.toUpperCase(),
  };
};

const http = httpService();
const product = {
  ...baseActions(URL_API_PRODUCT, path, actionType),
  updateStatus: (params) => {
    return (dispatch) => {
      dispatch({ type: actionType('updateStatus').request });
      return http.put(`${URL_API_PRODUCT}/products/status`, params).then(
        (response) => {
          dispatch({ type: actionType('updateStatus').success, response: response.data });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('updateStatus').error });
          throw error.response;
        },
      );
    };
  },
  deleteProduct: (id) => {
    return (dispatch) => {
      dispatch({ type: actionType('deleteProduct').request });
      return http.delete(`${URL_API_PRODUCT}/product-certifications/${id}`).then(
        (response) => {
          dispatch({ type: actionType('deleteProduct').success, response: response.data });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('deleteProduct').error });
          throw error.response;
        },
      );
    };
  },
};
export default product;
